/* eslint-disable no-unused-vars */
import { FreeZonePlateValue } from '@/common/components/base/input/plate/freeZonePlateInput/freeZonePlateInput.type';
import { plateValue } from '@/common/components/base/input/plate/vehiclePlateInput/vehiclePlateInput.type';
import { FileStateType, FileTypeConst } from '@/common/types/Files.type.ts';
import { SelectionOptionsType } from '@/common/types/SelectionOptions.type';

export enum MyFilesListQueryKey {
  ORDER_ID = 'order_id',
  INSURANCE = 'insurance',
  PLATE = 'plate',
  VEHICLE_TYPE = 'vehicle_type',
  PLATE_DESIGN = 'plate_design',
  FILE_TYPE = 'file_type',
  PHONE_NUMBER = 'phone_number',
  PAGE = 'page',
  PAGE_SIZE = 'page_size',
  SORT = 'sort',
  FORM_DATE = 'form_date',
  TO_DATE = 'to_date',
  STATE = 'state',
  RANGE_DATE = 'range_date',
}

type LabeledValue = {
  label: string;
  value: string;
};

type PlateDesign = LabeledValue & {
  enName: string;
};

export type MyFilesListParamsType = Partial<{
  [MyFilesListQueryKey.ORDER_ID]: string;
  [MyFilesListQueryKey.INSURANCE]: SelectionOptionsType<string | number>[];
  [MyFilesListQueryKey.PLATE]: plateValue | FreeZonePlateValue;
  [MyFilesListQueryKey.VEHICLE_TYPE]: PlateDesign;
  [MyFilesListQueryKey.PLATE_DESIGN]: PlateDesign;
  [MyFilesListQueryKey.FILE_TYPE]: SelectionOptionsType<FileTypeConst | 'all'>;
  [MyFilesListQueryKey.PHONE_NUMBER]: string;
  [MyFilesListQueryKey.PAGE]: number;
  [MyFilesListQueryKey.PAGE_SIZE]: number;
  [MyFilesListQueryKey.SORT]: SelectionOptionsType<'newest' | 'oldest'>;
  [MyFilesListQueryKey.FORM_DATE]: string;
  [MyFilesListQueryKey.TO_DATE]: string;
  [MyFilesListQueryKey.STATE]: { label: string; value: FileStateType };
  [MyFilesListQueryKey.RANGE_DATE]: { label: string; value: FileStateType };
}>;
export type MyFilesListQueryParamsType = Partial<{
  [MyFilesListQueryKey.ORDER_ID]: string;
  [MyFilesListQueryKey.INSURANCE]: string;
  [MyFilesListQueryKey.PLATE]:
    | plateValue['plateString']
    | FreeZonePlateValue['plateString'];
  [MyFilesListQueryKey.VEHICLE_TYPE]: LabeledValue['value'];
  [MyFilesListQueryKey.PLATE_DESIGN]: PlateDesign['enName'];
  [MyFilesListQueryKey.FILE_TYPE]: FileTypeConst | 'all';
  [MyFilesListQueryKey.PHONE_NUMBER]: string;
  [MyFilesListQueryKey.PAGE]: number;
  [MyFilesListQueryKey.PAGE_SIZE]: number;
  [MyFilesListQueryKey.SORT]: 'newest' | 'oldest';
  [MyFilesListQueryKey.FORM_DATE]: string;
  [MyFilesListQueryKey.TO_DATE]: string;
  [MyFilesListQueryKey.STATE]: FileStateType;
  [MyFilesListQueryKey.RANGE_DATE]: string;
}>;
